<div style="max-width: 100%;">
  <dx-data-grid class="h-100"
                [dataSource]="fotoWareImportSettings"
                [remoteOperations]="false"
                [allowColumnReordering]="true"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"
                [showBorders]="true"
                [showColumnHeaders]="true"
                (onRowUpdated)="onRowUpdated($event)"
                (onRowRemoved)="onRowRemoved($event)"
                (onRowInserted)="onRowInserted($event)"
                (onInitNewRow)="onInitNewRow($event)">

    <dxo-paging [pageSize]="50"></dxo-paging>
    <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
    <dxo-editing mode="cell" [allowUpdating]="isManager()" [allowDeleting]="isManager()" [allowAdding]="isManager()"></dxo-editing>

    <dxi-column dataField="host" caption="{{ 'Host-URL' | translate }}">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="clientId" caption="{{ 'Client Id' | translate }}">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="clientSecret" caption="{{ 'Client Secret' | translate }}"
                cellTemplate="secretTemplate"
                editCellTemplate="secretEditTemplate">
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'secretTemplate'">{{ cellInfo.value ? '********' : '' }}</div>
    <div *dxTemplate="let cellInfo of 'secretEditTemplate'">
      <dx-text-box mode="password"
                   [value]="cellInfo.value"
                   (onValueChanged)="cellInfo.setValue($event.value)">
      </dx-text-box>
    </div>
    <dxi-column dataField="imageArchivePath" caption="{{ 'Archivpfad Bilder' | translate }}">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="documentArchivePath" caption="{{ 'Archivpfad Dokumente' | translate }}"></dxi-column>
    <dxi-column dataField="time" dataType="datetime" caption="{{ 'Uhrzeit' | translate }}"
                format="HH:mm"
                editCellTemplate="timeTemplate"
                showEditorAlways="true">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'timeTemplate'">
      <dx-date-box [(value)]="cellInfo.value"
                   (onValueChanged)="cellInfo.setValue($event.value)"
                   type="time"
                   pickerType="list"
                   [interval]="15">
      </dx-date-box>
    </div>
    <dxi-column dataField="overlapDays" dataType="number" caption="{{ 'Überlappung (Tage)' | translate }}">
      <dxi-validation-rule type="range" [min]="0"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="fullSyncIntervalDays" dataType="number" caption="{{ 'Vollabgleich alle (Tage)' | translate }}">
      <dxi-validation-rule type="range" [min]="1"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="active" caption="{{ 'Aktiv' | translate }}" dataType="boolean"></dxi-column>

    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
    <div *dxTemplate="let column of 'detail'">
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Letzte Ausfuehrung' | translate }}</div>
          <div class="dx-field-value">
            <dx-date-box type="datetime" [value]="column.data.lastRun" [readOnly]="true"></dx-date-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Letzter erfolgreicher Import' | translate }}</div>
          <div class="dx-field-value">
            <dx-date-box type="datetime" [value]="column.data.lastSuccessfulRun" [readOnly]="true"></dx-date-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Letzter Vollabgleich' | translate }}</div>
          <div class="dx-field-value">
            <dx-date-box type="datetime" [value]="column.data.lastFullSync" [readOnly]="true"></dx-date-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label"></div>
          <div class="dx-field-value" style="text-align: right;">
            <dx-button text="{{ 'Verbindung testen' | translate }}" (onClick)="testConnection(column.data)" icon="check"></dx-button>
            <dx-button text="{{ 'Manuell ausführen' | translate }}" (onClick)="run(column.data, false)" icon="redo" [disabled]="!isManager()"></dx-button>
            <dx-button text="{{ 'Vollabgleich starten' | translate }}" (onClick)="run(column.data, true)" icon="refresh" [disabled]="!isManager()"></dx-button>
          </div>
        </div>
      </div>
    </div>
  </dx-data-grid>
</div>
